import { TrendingUp, Megaphone, Wallet, Headphones, Briefcase } from "lucide-react";

// Shared product/pillar catalogue used by the Home grid and the Services page.
// `tag` = the text-column label; `card` (optional) overrides the agent-card title.
export const PILLARS = [
    {
        id: "sales",
        num: "01",
        tag: "SALES",
        icon: TrendingUp,
        headline: "Streamline Your Sales Pipeline",
        bullets: [
            {
                lead: "Syncs New Leads:",
                desc: "Instantly captures leads from Google and Meta ads and imports them straight into your local CRM database.",
            },
            {
                lead: "AI Sales Assistant:",
                desc: "Automatically drafts personalised WhatsApp follow-ups so you never lose a hot deal by waiting.",
            },
            {
                lead: "Instant Quotations:",
                desc: "Converts won CRM deals into professional invoices and quotes with zero manual double-entry.",
            },
        ],
    },
    {
        id: "marketing",
        num: "02",
        tag: "MARKETING",
        icon: Megaphone,
        headline: "Maximise Your Marketing ROI",
        bullets: [
            {
                lead: "Instant Lead Route:",
                desc: "Instantly assigns incoming website and ad leads to the right sales reps for immediate action.",
            },
            {
                lead: "Smart Ad Campaigns:",
                desc: "Runs highly targeted email and WhatsApp nurturing flows based on real-time client behaviour.",
            },
            {
                lead: "Predicts Campaign Wins:",
                desc: "Automatically analyses engagement trends and highlights which channels drive the most revenue.",
            },
        ],
    },
    {
        id: "finance",
        num: "03",
        tag: "FINANCE & ACCOUNTING",
        card: "FINANCE",
        icon: Wallet,
        headline: "Automate Compliance & Reconciliation",
        bullets: [
            {
                lead: "LHDN e-Invoice Sync:",
                desc: "Instantly formats, validates, and submits transaction payloads to LHDN's MyInvois API to ensure full compliance.",
            },
            {
                lead: "Chases Late Payments:",
                desc: "Automatically sends payment reminders and flags overdue invoices before they become a cash flow problem.",
            },
            {
                lead: "Reads Receipts & Invoices:",
                desc: "Scans and extracts data from invoices and receipts with high accuracy, matched to Malaysian e-Invoice (LHDN) and SST requirements.",
            },
        ],
    },
    {
        id: "customer-support",
        num: "04",
        tag: "CUSTOMER SUPPORT",
        icon: Headphones,
        headline: "Deliver Instant Multilingual Help",
        bullets: [
            {
                lead: "Code-Switching AI Chat:",
                desc: "Answers support queries instantly in a natural mix of Bahasa Melayu, English, and Mandarin.",
            },
            {
                lead: "Live Inventory Lookups:",
                desc: "Directs WhatsApp clients to active stock availability and catalogues without manual checks.",
            },
            {
                lead: "Human-Handover Routing:",
                desc: "Automatically flags complex tickets and hands them off smoothly to live agents.",
            },
        ],
    },
    {
        id: "admin-operations",
        num: "05",
        tag: "ADMIN & OPERATIONS",
        icon: Briefcase,
        headline: "Take the Busywork Off Your Plate",
        bullets: [
            {
                lead: "Drafts Documents & Contracts:",
                desc: "Generates SOPs, quotations, and standard contracts from a template, ready for a quick human review instead of a blank page.",
            },
            {
                lead: "Tracks Inventory & Stock:",
                desc: "Monitors stock levels across your outlets or channels and flags reorder points before you run out or overbuy.",
            },
            {
                lead: "Manages Internal Requests:",
                desc: "Handles staff leave requests, IT tickets, and procurement approvals through chat, routing each one to the right person automatically.",
            },
        ],
    },
];
